/* eslint-disable react/no-set-state */
import React from 'react';

const style = {
  backgroundColor: '#ffffff',
  border: '1px solid #d0d0d0',
  borderRadius: '10px',
  padding: '20px 15px',
  color: '#36449d'
};
const containerStyle = {
  display: 'flex',
  justifyContent: 'center'
};

const RefreshIndicator = () => (
  <div className='align-center' style={containerStyle}>
    <div style={style}>
      Property data is currently being refreshed. Please come back in 15-30
      minutes.
    </div>
  </div>
);

export default RefreshIndicator;
